export const CREATE_PROJECT = '@@create_project';
export const CREATE_PROJECT_SUCCESS = '@@create_project_Success';
export const CREATE_PROJECT_FAILURE = '@@create_project_failure';

export const FETCH_PROJECT_LIST = '@@fetch_Project_List';
export const FETCH_PROJECT_LIST_SUCCESS = '@@fetch_Project_List_Success';
export const FETCH_PROJECT_LIST_FAILURE = '@@fetch_Project_List_Failure';

export const UPDATE_PROJECT = '@@update_Project';
export const UPDATE_PROJECT_SUCCESS = '@@update_Project_Success';
export const UPDATE_PROJECT_FAILURE = '@@update_Project_Failure';

export const DELETE_PROJECT = '@@delete_Project';
export const DELETE_PROJECT_SUCCESS = '@@delete_Project_Success';
export const DELETE_PROJECT_FAILURE = '@@delete_Project_Failure';

export const BULK_DELETE_PROJECTS = '@@bulk_delete_Projects';
export const BULK_DELETE_PROJECTS_SUCCESS = '@@bulk_delete_Projects_Success';
export const BULK_DELETE_PROJECTS_FAILURE = '@@bulk_delete_Projects_Failure';